import * as signalR from '@aspnet/signalr';

export class SignalRConnectionWrapper {
    private readonly _hubConnection: signalR.HubConnection;
    private readonly _onClosed: () => void;
    private _suppressReconnection: boolean = false;

    constructor(hubConnection: signalR.HubConnection, onClosed: () => void) {
        this._hubConnection = hubConnection;
        this._onClosed = onClosed;

        this._hubConnection.onclose(() => {
            if (this._suppressReconnection) return;

            this._onClosed();
        });
    }

    public async abortConnection() {
        this._suppressReconnection = true;

        try {
            await this._hubConnection.stop();
        } catch (e) {
            console.error(e);
        }
    }
}
